import React, { useMemo, useState } from 'react';
import { api } from '../services/api';

function getTokenFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('token') || '';
  } catch {
    return '';
  }
}

export default function SetPassword() {
  // Token is only ever sourced from the invite/reset link.
  // Never render it in the UI (tokens are credentials).
  const token = useMemo(() => getTokenFromUrl(), []);
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!token.trim()) {
      setStatus({ type: 'error', text: 'Missing token' });
      return;
    }
    if (!pw1 || pw1.length < 8) {
      setStatus({ type: 'error', text: 'Password must be at least 8 characters' });
      return;
    }
    if (pw1 !== pw2) {
      setStatus({ type: 'error', text: 'Passwords do not match' });
      return;
    }

    setLoading(true);
    try {
      await api.resetPassword(token, pw1);
      // Show a one-time success banner on the login screen after redirect.
      try {
        sessionStorage.setItem('flash_login_success', 'Password set. Please log in.');
      } catch (e) {}
      window.location.href = '/';
    } catch (err) {
      setStatus({ type: 'error', text: err.message || 'Reset failed' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 520, margin: '0 auto', padding: 24 }}>
      <h1 style={{ color: '#f1f5f9', margin: '0 0 8px 0' }}>Set your password</h1>
      <p style={{ color: '#94a3b8', marginTop: 0 }}>
        Use the invite / reset link you were sent.
      </p>

      {status && (
        <div
          style={{
            padding: '12px 16px',
            borderRadius: 8,
            marginBottom: 16,
            background: status.type === 'success' ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)',
            color: status.type === 'success' ? '#86efac' : '#fca5a5',
          }}
        >
          {status.text}
        </div>
      )}

      <form onSubmit={submit} style={{ background: '#1e293b', padding: 20, borderRadius: 12, border: '1px solid #334155' }}>
        <label style={{ display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 }}>New password</label>
        <input
          type="password"
          value={pw1}
          onChange={(e) => setPw1(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            background: '#0f172a',
            border: '1px solid #334155',
            borderRadius: 6,
            color: '#f1f5f9',
            marginBottom: 12,
          }}
        />

        <label style={{ display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 }}>Confirm password</label>
        <input
          type="password"
          value={pw2}
          onChange={(e) => setPw2(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            background: '#0f172a',
            border: '1px solid #334155',
            borderRadius: 6,
            color: '#f1f5f9',
            marginBottom: 16,
          }}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            background: 'var(--brand-primary, #3b82f6)',
            border: 'none',
            borderRadius: 8,
            color: '#fff',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {loading ? 'Saving…' : 'Set password'}
        </button>
      </form>

      <div style={{ marginTop: 16, color: '#64748b', fontSize: 13 }}>
        <a href="/" style={{ color: '#93c5fd' }}>
          Back to app
        </a>
      </div>
    </div>
  );
}
